import { gql } from 'urql';
import { PRODUCT } from '../client';
import { GGetEcomBulkItemsQuery } from '../types/generated';

export const GET_ECOM_BULK_ITEMS = gql<GGetEcomBulkItemsQuery>`
  query ${PRODUCT}GetEcomBulkItems($input: WarehouseEcomBulkItemsInput!, $first: Int) {
    warehouseEcomBulkItems(input: $input, first: $first) {
      nodes {
        ... on InventoryItem {
          id
          name
        }
        ... on NonInventoryItem {
          id
          name
        }
      }
    }
  }
`;
